import * as React from 'react';
import { Provider } from 'react-redux';
import AppContainer from './AppContainer';

const Root = ({ store }: any) => {
    return (
        <Provider store={store}>
            <AppContainer />
        </Provider>
    );
};

export default Root;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Root.tsx